import React, { memo, FC, useEffect } from 'react'

import { useSetFocus } from '@please/lrud'

import { Button } from '@/components/Button/Button'
import { focusIds } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'

import { PopUpBox, PopUpElem, Title, Description } from './styles'

const DialogPopUpRaw: FC = () => {
  const popUp = useStore((state) => state.common.popUp)
  const setPopUp = useStore((state) => state.common.setPopUp)
  const setFocus = useSetFocus()
  const { t } = useCommonTranslation()

  useEffect(() => {
    popUp && setFocus(focusIds.POPUP)
  }, [popUp])

  const handleContinue = () => {
    popUp?.prevFocusId && setFocus(popUp.prevFocusId)
    setPopUp(null)
  }

  return popUp ? (
    <PopUpBox focusId={focusIds.POPUP} isTrap={true}>
      <PopUpElem>
        {popUp.title && <Title>{popUp.title}</Title>}
        {popUp.description && <Description>{popUp.description}</Description>}
        <Button
          iconSrc={icons.navigation.check}
          text={popUp.buttonLabel || t('continue')}
          onClick={handleContinue}
        />
      </PopUpElem>
    </PopUpBox>
  ) : null
}

export const DialogPopUp = memo(DialogPopUpRaw)
